var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("© 2020 "+_vm._s(_vm.$store.getters.getSiteInfo.name)+" , All Rights Reserved "+_vm._s(_vm.$store.getters.getSiteInfo.beian))])])
}
var staticRenderFns = []

export { render, staticRenderFns }